import cxOmsImg from "public/cxPhoneSystem/3cxOMS.png";

export const ONE_MIND_CX_CONSTANTS = {
  IMAGE: cxOmsImg,
  DESCRIPTION: {
    title: "Hosted 3CX PBX, Simplified by OneMind ",
    description:
      "We handle the complexity so you can focus on delivering a seamless communication experience.",
    btnText: "Get Your Free Demo",
  },
};
